// Phone number validation utility for Indian mobile numbers
export const validatePhoneNumber = (phoneNumber) => {
  // Remove all non-digit characters
  const cleanNumber = phoneNumber.replace(/\D/g, '');
  
  // Check if it's exactly 10 digits
  if (cleanNumber.length !== 10) {
    return {
      isValid: false,
      message: 'Phone number must be exactly 10 digits'
    };
  }
  
  // Check if it starts with valid Indian mobile prefixes (6, 7, 8, 9)
  const firstDigit = cleanNumber.charAt(0);
  if (!['6', '7', '8', '9'].includes(firstDigit)) {
    return {
      isValid: false,
      message: 'Phone number must start with 6, 7, 8, or 9'
    };
  }
  
  return {
    isValid: true,
    message: 'Valid phone number',
    formattedNumber: cleanNumber
  };
};

// Format phone number for display
export const formatPhoneNumber = (phoneNumber) => {
  const cleanNumber = phoneNumber.replace(/\D/g, '');
  if (cleanNumber.length === 10) {
    return `${cleanNumber.slice(0, 5)} ${cleanNumber.slice(5)}`;
  }
  return phoneNumber;
};

// Handle phone input change with validation
export const handlePhoneInputChange = (value, setError) => {
  const validation = validatePhoneNumber(value);
  
  if (value && !validation.isValid) {
    setError(validation.message);
  } else {
    setError('');
  }
  
  return validation.formattedNumber || value;
};
